import { OnboardingProgress } from './tour.types'
import { WorkspaceOnboarding } from '../../types/specification'

export const ONBOARDING_VERSION = 'v3'
const LEGACY_STORAGE_PREFIX = 'grc_onboarding'

export const defaultProgress: OnboardingProgress = {
  status: 'pending',
  stepIndex: 0,
  version: ONBOARDING_VERSION,
  updatedAt: 0,
}

const toTimestamp = (value?: string | number | Date) => {
  if (!value) return 0
  if (typeof value === 'number') return value
  const parsed = new Date(value).getTime()
  return Number.isFinite(parsed) ? parsed : 0
}

export const readUserOnboarding = (
  onboarding: WorkspaceOnboarding | undefined,
  username?: string | null
): OnboardingProgress => {
  if (!onboarding || onboarding.version !== ONBOARDING_VERSION) {
    return defaultProgress
  }

  const safeUser = username?.trim()
  if (!safeUser) {
    return defaultProgress
  }

  const entry = (onboarding.users || []).find(
    (user) => user.username === safeUser
  )
  if (!entry) {
    return defaultProgress
  }

  return {
    status: entry.status || 'pending',
    stepIndex: Number.isFinite(entry.stepIndex) ? entry.stepIndex : 0,
    version: ONBOARDING_VERSION,
    updatedAt: toTimestamp(entry.updatedAt),
  }
}

export const clearLegacyOnboardingStorage = () => {
  try {
    const keysToRemove: string[] = []
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i)
      if (key && key.startsWith(LEGACY_STORAGE_PREFIX)) {
        keysToRemove.push(key)
      }
    }
    keysToRemove.forEach((key) => localStorage.removeItem(key))
  } catch {
    // Ignore private-mode / blocked storage.
  }
}
